import { proxyCustomElement, HTMLElement, createEvent, h, Host } from '@stencil/core/internal/client';
import { I as IMask } from './index2.js';
import { C as CURRENCY_MASK } from './form-input-masks.js';
import { d as defineCustomElement$2 } from './form-control-error-text2.js';
import { d as defineCustomElement$1 } from './form-control-help-text2.js';

const MonetaryInput = /*@__PURE__*/ proxyCustomElement(class MonetaryInput extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.formControlInput = createEvent(this, "formControlInput", 7);
        this.formControlBlur = createEvent(this, "formControlBlur", 7);
        this.imask = null;
        this.initializeIMask = () => {
            if (!this.textInput)
                return;
            this.imask = IMask(this.textInput, this.maskOptions);
            this.imask.on('accept', () => {
                const rawValue = this.imask.unmaskedValue;
                this.inputHandler(this.name, rawValue);
                this.formControlInput.emit({ name: this.name, value: rawValue });
            });
            this.textInput.addEventListener('blur', () => this.formControlBlur.emit());
        };
        this.handleFormControlInput = (event) => {
            const target = event.target;
            const name = target.getAttribute('name');
            const rawValue = this.imask.unmaskedValue;
            this.formControlInput.emit({ name: name, value: rawValue });
        };
        this.updateInput = (newValue) => {
            if (this.imask) {
                this.imask.value = String(newValue);
            }
        };
        this.label = undefined;
        this.name = undefined;
        this.helpText = undefined;
        this.errorText = undefined;
        this.defaultValue = undefined;
        this.inputHandler = undefined;
        this.maskOptions = CURRENCY_MASK.DECIMAL;
        this.disabled = undefined;
    }
    handleDefaultValueChange(newValue) {
        this.updateInput(newValue);
    }
    componentDidLoad() {
        this.initializeIMask();
        this.updateInput(this.defaultValue);
    }
    disconnectedCallback() {
        var _a;
        (_a = this.imask) === null || _a === void 0 ? void 0 : _a.destroy();
    }
    render() {
        return (h(Host, { key: '6c95f96829b6cacc9d3fa975e1b9e81fa2011360', exportparts: "label,input,input-group-input,input-group-text,input-invalid" }, h("div", { key: 'e8343e6439d4a52d21991f9071caebb94789afdf', class: "form-group d-flex flex-column" }, h("label", { key: '5bff3a49dc18c407a8df5c96fd65720531bad45c', part: "label", class: "form-label", htmlFor: this.name }, this.label), h("div", { key: '012e6cddda14b939c898df2c8422cd21f10e18fa', class: "input-group" }, h("span", { key: 'a7fa4827a93a925472271630a4667b64d1fa99c2', class: "input-group-text", part: "input-group-text" }, "$"), h("input", { key: 'd0e8c3f4e7466ab2115cbbe03bc9f81759f32c10', ref: el => (this.textInput = el), id: this.name, name: this.name, onBlur: this.formControlBlur.emit, onInput: this.handleFormControlInput, part: `input input-group-input ${this.errorText && 'input-invalid'}`, class: this.errorText ? 'form-control monetary is-invalid' : 'form-control monetary', type: "text", disabled: this.disabled })), h("form-control-help-text", { key: '62f6cbc7dad3127d5461b8d003e9cf0a991373ff', helpText: this.helpText, name: this.name }), h("form-control-error-text", { key: '465b5a31b6434b2afc40ff4cc6d29713e5840fe8', errorText: this.errorText, name: this.name }))));
    }
    static get watchers() { return {
        "defaultValue": ["handleDefaultValueChange"]
    }; }
}, [0, "form-control-monetary", {
        "label": [1],
        "name": [1],
        "helpText": [1, "help-text"],
        "errorText": [1, "error-text"],
        "defaultValue": [1, "default-value"],
        "inputHandler": [16],
        "maskOptions": [8, "mask-options"],
        "disabled": [4]
    }, undefined, {
        "defaultValue": ["handleDefaultValueChange"]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["form-control-monetary", "form-control-error-text", "form-control-help-text"];
    components.forEach(tagName => { switch (tagName) {
        case "form-control-monetary":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, MonetaryInput);
            }
            break;
        case "form-control-error-text":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
        case "form-control-help-text":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { MonetaryInput as M, defineCustomElement as d };
